import zeroPad from '@/utils/zeroPad';
import { motion } from 'framer-motion';
import styles from './advantages.module.scss';
import { useInView } from 'react-intersection-observer';
import clsx from "clsx";

const Advantages = ({ data, isInvest }) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    rootMargin: '-100px 0px',
  });
  if (data.listing && Array.isArray(data.listing)) {
    return (
      <div ref={ref} className={clsx(styles.wrapper, styles['-invest'])}>
        {data.listing.map((advantage, k) => (
          <Advantage inView={inView} k={k + 1} advantage={advantage} key={advantage.id} isInvest={isInvest} />
        ))}
      </div>
    );
  }

  return null;
};

const variants = {
  initial: { opacity: 0 },
  visible: i => ({
    opacity: 1,
    transition: {
      duration: 1.3,
      delay: i * 0.3,
    },
  }),
  hidden: { opacity: 0 },
};

const Advantage = ({ advantage, k, inView, isInvest }) => {
  return (
    <motion.div
      data-num={zeroPad(k, 2)}
      className={clsx(styles.advantage, styles['-invest'])}
      custom={k}
      initial="initial"
      animate={inView ? 'visible' : 'false'}
      exit="hidden"
      variants={variants}
    >
      <div className={styles.headline}>{advantage.title}</div>
      <div className={styles.title}>{advantage.description}</div>
    </motion.div>
  );
};

export default Advantages;
